// extracted by css-extract-rspack-plugin
export default {"profile-info-row":"profile-info-row-petWAh","profileInfoRow":"profile-info-row-petWAh"};